import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';

/**
 * Экран состояния вместо приложения: бот выключен, Telegram не отдал данные,
 * мини-апп снят партнёром, сбой. Одна вёрстка на все случаи (раскладка «Карта»,
 * 19.10.2026): значок в круге, заголовок, пояснение, действие. Раньше у каждого
 * экрана был свой цвет и свой размер плитки, и они выглядели черновиками.
 */
export type StateTone = 'neutral' | 'warn' | 'danger';

const TONE: Record<StateTone, string> = {
  neutral: 'bg-[var(--t-surface-2)] text-[var(--t-muted)]',
  warn: 'bg-[color-mix(in_srgb,var(--t-warn)_14%,transparent)] text-[var(--t-warn)]',
  danger: 'bg-[color-mix(in_srgb,var(--t-danger)_14%,transparent)] text-[var(--t-danger)]',
};

export function StateScreen({
  icon,
  tone = 'neutral',
  title,
  description,
  children,
  className,
}: {
  icon: ReactNode;
  tone?: StateTone;
  title: ReactNode;
  description?: ReactNode;
  /** Кнопки и прочее под текстом. */
  children?: ReactNode;
  className?: string;
}) {
  return (
    <div className={cn('flex min-h-[80vh] flex-col items-center justify-center px-6 py-10 text-center', className)}>
      <span className={cn('grid size-[72px] place-items-center rounded-full [&_svg]:size-8 [&_svg]:[stroke-width:1.6]', TONE[tone])}>
        {icon}
      </span>
      <h1 className="mt-6 max-w-sm text-[26px] font-semibold leading-tight tracking-[-0.03em] text-foreground">{title}</h1>
      {description && <p className="mt-2 max-w-sm text-[15px] leading-snug text-[var(--t-muted)]">{description}</p>}
      {children && <div className="mt-8 flex w-full max-w-sm flex-col gap-2.5">{children}</div>}
    </div>
  );
}
